/**
 * @generated SignedSource<<70d7757587ce82998bda2ded924eb368>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteBlocksInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type ActionItemDeleteMutation$variables = {
  input: DeleteBlocksInput;
};
export type ActionItemDeleteMutation$data = {
  readonly deleteBlocks: {
    readonly deletedIds: ReadonlyArray<string>;
  } | null;
};
export type ActionItemDeleteMutation = {
  response: ActionItemDeleteMutation$data;
  variables: ActionItemDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteBlocksPayload",
    "kind": "LinkedField",
    "name": "deleteBlocks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64260851a24b0238c5f9eef7b9edb374",
    "id": null,
    "metadata": {},
    "name": "ActionItemDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemDeleteMutation(\n  $input: DeleteBlocksInput!\n) {\n  deleteBlocks(input: $input) {\n    deletedIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "c953ddfcfb2c6bca5b83203b94f01371";

export default node;
